import { motion } from "framer-motion";
import { Heart } from "lucide-react";

interface LoadingScreenProps {
  progress: number;
}

export function LoadingScreen({ progress }: LoadingScreenProps) {
  return (
    <motion.div
      className="fixed inset-0 z-[60] flex flex-col items-center justify-center bg-[#F7F5F2] text-stone-800"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.8, ease: "easeInOut" } }}
    >
      <div className="relative mb-8">
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 10, -10, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <Heart className="w-16 h-16 text-stone-400 fill-stone-400/20" />
        </motion.div>
      </div>

      <h2 className="font-handwriting text-3xl mb-6">Rifa & Nauval</h2>

      <div className="w-64 h-1 bg-stone-300 rounded-full overflow-hidden mb-4">
        <motion.div
          className="h-full bg-stone-600"
          initial={{ width: "0%" }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.2 }}
        />
      </div>

      <p className="font-serif text-sm text-stone-500 animate-pulse">
        Preparing our special day... {Math.round(progress)}%
      </p>
    </motion.div>
  );
}
